import { tmrDialogController } from 'tmr/controllers/dialog/dialog'
import templateUrl from './unexpectedItemsDialog.html'

/**
 * Configures dialog Items by Upc (preset `tmrUnexpectedItems`).
 *
 * @type {ngConfig}
 */
function tmrUnexpectedItemsDialogConfig($mdDialogProvider) {
  'ngInject'
  $mdDialogProvider.addPreset('tmrUnexpectedItems', {
    options: /*@ngInject*/ () => ({
      templateUrl,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: 'tmrUnexpectedItemsDialogController',
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        inventory: null,
      },
      resolve: {
        productImageEnabled: /*@ngInject*/ TmrAppConfiguration =>
          TmrAppConfiguration.get('product.image.enabled'),
      },
    }),
  })
}

export { tmrUnexpectedItemsDialogConfig as config }

/**
 * Controller of Dialog {@link tmrUnexpectedItemsDialogConfig tmrUnexpectedItems}.
 *
 * @type {ngController}
 */
export class tmrUnexpectedItemsDialogController extends tmrDialogController {
  constructor(
    $mdDialog,
    $transitions,
    TmrInfiniteScrollResources,
    InventoryItem
  ) {
    'ngInject'
    super($mdDialog, $transitions)
    Object.assign(this, { TmrInfiniteScrollResources, InventoryItem })
  }

  $onInit() {
    super.$onInit()
    this.inventoryItems = new this.TmrInfiniteScrollResources(
      this.InventoryItem,
      {
        id: this.inventory.id,
        expected: false,
        detected: true,
        orderBy: 'DETECTION_DATE',
      }
    )
  }
}
